import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const offices = [
  { city: 'Coimbatore', address: 'No 1209/2, Sai Imperia Grand, Mettupalayam Road, Saibaba Colony, Coimbatore - 641011' },
  { city: 'Pollachi', address: '83/14 1st Floor, Angel Broking, Vallar Street, Bus Stand Back Side, Pollachi - 642001' },
  { city: 'Udumalpet', address: '8/9 2nd Floor, Angel Broking, 100 Feet Road, Abirami Nagar, Udumalpet - 642126' },
];
const usefulLinks = [
  { label: 'Home', to: '/' }, { label: 'About Us', to: '/about' },
  { label: 'Courses', to: '/services' }, { label: 'Contact', to: '/contact' }
];

const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/share/18YiUdELbi/', d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' },
  { label: 'YouTube', href: 'https://youtube.com/@mrsirusemippu?si=9Gu3DttjuFmiMQ63', d: 'M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33zM9.75 15.02l5.75-3.27-5.75-3.27z' },
  { label: 'Instagram', href: 'https://www.instagram.com/mrsirusemippu?igsh=MWlwZnU2dTM4b3B2Yg==', d: 'M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9a5.5 5.5 0 0 1-5.5 5.5h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2zm4.5 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm5.25-3.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5' },
  { label: 'WhatsApp', href: 'https://wa.me/919345351177', d: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.654-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z M12 2a10 10 0 0 0-8.6 15.1L2 22l4.9-1.3A10 10 0 1 0 12 2z' },
];

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(255,255,255,0.05)] bg-[#4a7d39] text-white w-full transition-colors font-inter">
      <div className="container-fluid py-10 lg:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
        {/* Col 1 — Brand */}
        <div className="space-y-4">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl overflow-hidden border border-white/10 bg-white shrink-0 p-1">
              <img src="/stone-bench-logo.jpeg" alt="Stone Bench" className="w-full h-full object-contain" onError={e => { e.currentTarget.style.display = 'none'; }} />
            </div>
            <div>
              <p className="text-sm font-black tracking-tight text-white">STONE BENCH</p>
              <p className="text-[9px] font-bold uppercase tracking-[0.15em] text-white">Investments</p>
            </div>
          </Link>
          <p className="text-sm leading-relaxed text-white/70">Your trusted financial partner for stock market, insurance, and real estate solutions across Tamil Nadu.</p>
          <div className="flex gap-2">
            {socials.map(s => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="w-8 h-8 rounded-full border border-white flex items-center justify-center text-white/60 hover:text-[var(--color-accent)] hover:border-[var(--color-accent)] transition-all">
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={s.d} /></svg>
              </a>
            ))}
          </div>
        </div>

        {/* Col 2 — Contact */}
        <div className="space-y-4">
          <h3 className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/100">Contact Info</h3>
          <div className="space-y-3">
            <a href="tel:+91 93453 51177" className="flex items-start gap-3 group">
              <div className="w-8 h-8 rounded-full border border-[#fff] flex items-center justify-center shrink-0 group-hover:border-[var(--color-accent)] transition-colors">
                <Phone className="w-3.5 h-3.5 text-[#fff]" />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-wider text-white/80 mb-0.5">Phone</p>
                <p className="text-sm font-semibold text-white group-hover:text-[var(--color-accent)] transition-colors">+91 93453 51177</p>
              </div>
            </a>
            <a href="mailto:stonebenchinvestments@gmail.com" className="flex items-start gap-3 group">
              <div className="w-8 h-8 rounded-full border border-white flex items-center justify-center shrink-0 group-hover:border-[var(--color-accent)] transition-colors">
                <Mail className="w-3.5 h-3.5 text-white" />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase tracking-wider text-white/80 mb-0.5">Email</p>
                <p className="text-xs sm:text-sm font-semibold text-white group-hover:text-[var(--color-accent)] transition-colors break-all">stonebenchinvestments@gmail.com</p>
                <p className="text-[10px] text-white/90 mt-0.5">We reply within 1 business day</p>
              </div>
            </a>
          </div>
        </div>

        {/* Col 3 — Offices */}
        <div className="space-y-4">
          <h3 className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/100">Our Offices</h3>
          <div className="space-y-3.5">
            {offices.map(o => (
              <div key={o.city} className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-full border border-white flex items-center justify-center shrink-0 mt-0.5">
                  <MapPin className="w-3 h-3 text-white" />
                </div>
                <div>
                  <p className="text-[11px] font-bold text-white mb-0.5">{o.city}</p>
                  <p className="text-[11px] text-white/90 leading-snug">{o.address}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Col 4 — Links */}
        <div className="space-y-4">
          <h3 className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/100">Useful Links</h3>
          <div className="space-y-1.5">
            {usefulLinks.map(l => (
              <Link key={l.to} to={l.to} className="flex items-center gap-2 text-sm font-medium text-white hover:text-[var(--color-accent)] transition-all group">
                <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] opacity-0 group-hover:opacity-100 transition-opacity" />
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 bg-black/20">
        <div className="container-fluid py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[12px] text-white/40 italic font-medium">© {new Date().getFullYear()} Stone Bench Investments · Built with Precision.</p>
          <div className="flex gap-6">
            <a href="/privacy-policy" target='_blank' className="text-[11px] font-bold uppercase tracking-widest text-white/30 hover:text-[var(--color-accent)] transition-colors">Privacy Policy</a>
            <a href="/terms-and-conditions.html" target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold uppercase tracking-widest text-white/30 hover:text-[var(--color-accent)] transition-colors">Terms and Conditions</a>
            <a href="/refund-cancellation-policy.html" target="_blank" rel="noopener noreferrer" className="text-[11px] font-bold uppercase tracking-widest text-white/30 hover:text-[var(--color-accent)] transition-colors">Refund/Cancellation Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}